import { ValidationErrors } from 'final-form';

import { validateCronExpressionOfTask } from './cronExpression';
import { validateLookBackPeriod } from './lookBackPeriodValidator';
import {
  ADHERENCE_LOOK_BACK_MAX_VALUE,
  ADHERENCE_LOOK_BACK_MIN_VALUE,
} from '../../components/forms/jobs/adherence/AdherenceData';
import { LOOK_BACK_MAX_VALUE, LOOK_BACK_MIN_VALUE } from '../../components/forms/jobs/historicalData/HistoricalData';
import {
  AdherenceTaskType,
  HistoricalDataImportTaskType,
  WebexCCConfigurationType,
} from '../../scene/integrations/types';

/**
 * Validations for fields that can be statically validated should be placed directly in `Field` component
 * or `useField` hook.
 *
 * This form validation should serve for applying dynamic validators that relies on another fields.
 * Used validator are determined after changes on fields in order to avoid generating some random `key`
 * ([docs](https://final-form.org/docs/react-final-form/types/FieldProps#validate)) to trigger field level validation.
 */
export const validateWXCCForm = (values: WebexCCConfigurationType): ValidationErrors => ({
  tasks: [
    {
      // user sync
      cronExpression: validateCronExpressionOfTask(values.tasks[0]),
    },
    {
      // adherence data
      cronExpression: validateCronExpressionOfTask(values.tasks[1]),
      taskProperties: {
        lookBackPeriod: validateLookBackPeriod(
          values.tasks[1] as AdherenceTaskType,
          ADHERENCE_LOOK_BACK_MIN_VALUE,
          ADHERENCE_LOOK_BACK_MAX_VALUE
        ),
      },
    },
    {
      // historical data
      cronExpression: validateCronExpressionOfTask(values.tasks[2]),
      taskProperties: {
        lookBackPeriod: validateLookBackPeriod(
          values.tasks[2] as HistoricalDataImportTaskType,
          LOOK_BACK_MIN_VALUE,
          LOOK_BACK_MAX_VALUE
        ),
      },
    },
  ],
});
